const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.trackyourwheelz.com/api";
const API_ORIGIN = API_BASE_URL.replace(/\/api\/?$/, "");

export function resolveVehicleImageUrl(url) {
  if (!url) return null;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  if (url.startsWith("http://") || url.startsWith("https://")) return url;

  const base = API_ORIGIN.endsWith("/") ? API_ORIGIN.slice(0, -1) : API_ORIGIN;
  const path = url.startsWith("/") ? url : `/${url}`;
  return `${base}${path}`;
}

export function isImageFile(file) {
  if (!file) return false;
  if (file.type && file.type.startsWith("image/")) return true;
  const name = (file.name || "").toLowerCase();
  return /\.(jpe?g|png|gif|webp|heic|heif|bmp)$/i.test(name);
}

export function compressImageFile(file, { maxWidth = 600, maxHeight = 400, quality = 0.75 } = {}) {
  return new Promise((resolve, reject) => {
    if (!isImageFile(file)) {
      reject(new Error("Please upload a valid image file."));
      return;
    }

    const reader = new FileReader();

    reader.onload = (event) => {
      const image = new Image();

      image.onload = () => {
        const widthRatio = maxWidth / image.width;
        const heightRatio = maxHeight / image.height;
        const ratio = Math.min(1, widthRatio, heightRatio);

        const targetWidth = Math.max(1, Math.round(image.width * ratio));
        const targetHeight = Math.max(1, Math.round(image.height * ratio));

        const canvas = document.createElement("canvas");
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, targetWidth, targetHeight);

        const dataUrl = canvas.toDataURL("image/jpeg", quality);

        resolve({
          dataUrl,
          previewUrl: event.target?.result || dataUrl,
        });
      };

      image.onerror = () =>
        reject(
          new Error(
            "Unable to read the selected image. Try JPG or PNG, or pick from gallery."
          )
        );

      image.src = event.target?.result;
    };

    reader.onerror = () =>
      reject(new Error("Unable to process the selected image. Please try again."));

    reader.readAsDataURL(file);
  });
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.rel = "noopener";
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();

  window.setTimeout(() => {
    link.remove();
    URL.revokeObjectURL(url);
  }, 1000);
}
